var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcelIcon = function SvgExcelIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-1234.000000, -304.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1237.42857,308.642857 L1237.42857,306.214286 C1237.42857,305.543654 1237.97223,305 1238.64286,305 L1250.78571,305 C1251.45636,305 1252,305.543654 1252,306.214286 L1252,320.785714 C1252,321.456364 1251.45636,322 1250.78571,322 L1238.64286,322 C1237.97223,322 1237.42857,321.456364 1237.42857,320.785714 L1237.42857,318.357143 M1237.42857,311.071429 L1242.28571,315.928571 M1237.42857,315.928571 L1242.28571,311.071429 M1236.21429,308.642857 L1243.5,308.642857 C1244.17063,308.642857 1244.71429,309.186517 1244.71429,309.857143 L1244.71429,317.142857 C1244.71429,317.813507 1244.17063,318.357143 1243.5,318.357143 L1236.21429,318.357143 C1235.54365,318.357143 1235,317.813507 1235,317.142857 L1235,309.857143 C1235,309.186517 1235.54365,308.642857 1236.21429,308.642857 Z",
    id: "Shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcelIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/excelIcon.b3d9285c0cf3186e98e5e0e58659dc40.svg";